import React from 'react';
import styled from 'styled-components';


let bgColor = `#fff9cc`
let primaryColor = `#927C07`
let borderLine = `1.9px`

const TicketWrapper = styled.div`
  overflow: hidden;
`

const Ticket = styled.div`
  display: flex;
  align-items: center;
  background-color: ${bgColor};
  color: ${primaryColor};
  border: ${borderLine} solid ${primaryColor};
  font-weight: bold;
  font-size: 10px;
  height: ${props => props.height + 'px'};
  border-radius: 5px;
  & div {
    display: flex;
  }
  & .label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px -1px;
    width: ${props => props.width + 'px'};
    
    .icon {
      margin-right: 6px;
      font-size: 2px;
    }

    .text {
      white-space: nowrap;
      margin-top: -0.5px;
    }
  }
`;

const Circle = styled.div`
  position: relative;
  width: ${props => (props.height - 20) + 'px'};
  height: ${props => (props.height - 20) + 'px'};
  border-radius: 50%;
  border: ${borderLine} solid transparent;
  transform: rotate(45deg);
  z-index: 1;
  background: #FFFCD7;

  ${props => {
    if(props.side === 'right') {
      return `
        border-bottom-color: ${primaryColor};
        border-left-color: ${primaryColor};
        left: 9px;
      `
    } else {
      return `
        border-top-color: ${primaryColor};
        border-right-color: ${primaryColor};
        right: 9px;
      `
    }
  }}
`

const TicketBadge = ({ text, icon, styles }) => {

  const { height = 40, width = 130 } = styles

  return (
    <TicketWrapper>
      <Ticket height={height} width={width}>
        <Circle side={'left'} height={height}/>
        <div className='label'>
          <div className='icon'>{icon}</div>
          <div className='text'>{text}</div>
        </div>
        <Circle side={'right'} height={height}/>
      </Ticket>
    </TicketWrapper>
  )
}

export { TicketBadge };
export default TicketBadge;
